var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page"},[_c('div',{staticClass:"error-page-wrap"},[_vm._m(0),_c('div',{staticClass:"error-page__title"},[_vm._v(" "+_vm._s(_vm.$t(_vm.errMsg))+" ")]),_c('div',{staticClass:"error-page__description"},[_vm._v(" "+_vm._s(_vm.errDesc)+" ")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page__logo"},[_c('img',{attrs:{"src":require("@/assets/404.svg")}})])
}]

export { render, staticRenderFns }